import { http } from "./http";

/** Adresse de contact publique de Permio : le repli quand un signalement ne part pas. */
export const SUPPORT_EMAIL = "contact@permio.fr";

export const supportApi = {
  /**
   * Signale un problème au service technique Permio, par e-mail. Le serveur ajoute le compte,
   * l'école et le navigateur ; `page` est le chemin de la page d'où part le signalement.
   */
  report: async (payload: { message: string; page?: string }) =>
    (
      await http.post<{ sent: boolean; replyTo: string | null }>(
        "/v1/support/reports",
        payload,
      )
    ).data,
};
